import { Component, OnInit } from '@angular/core';
import { Profile } from '@app/definitions/interfaces';
import { AccountService } from '@app/teacher/services/account.service';
import { GROUPS } from '@app/app.constants';

@Component({
    selector: 'app-profile-main',
    templateUrl: './profile-main.component.html',
    styleUrls: ['./profile-main.component.scss']
})
export class ProfileMainComponent implements OnInit {
    profile: Profile;
    is_teacher: boolean = false;
    is_teacher_helper: boolean = false;
    is_parent: boolean = false;
    is_student: boolean = false;
    is_super_user: boolean = false;

    constructor(private accountService: AccountService) {}

    ngOnInit() {
        this.accountService.getProfileData().subscribe(resp => {
            this.profile = resp.data;

            this.checkGroup();
        });
    }

    private checkGroup(): void {
        if (this.profile.group.name === GROUPS.PARENT) {
            this.is_parent = true;
        }

        if (this.profile.group.name === GROUPS.TEACHER) {
            this.is_teacher = true;
        }

        if (this.profile.group.name === GROUPS.TEACHER_HELPER) {
            this.is_teacher_helper = true;
        }

        if (this.profile.group.name === GROUPS.STUDENT) {
            this.is_student = true;
        }

        if (this.profile.group.name === GROUPS.SUPER_NAVIGATOR) {
            this.is_super_user = true;
        }
    }
}
